export type NotificationPriority = 1 | 2 | 3 | 4 | 5;

export enum NotificationAction {
	BILLING_CHANGE = 'BILLING_CHANGE', // BILLING_CHANGE
	UNKNOWN = 'UNKNOWN', // UNKNOWN
	NONE = 'NONE', // NONE
}

export interface TNotification {
	uuid: string;
	title: string;
	body: string;
	priority: NotificationPriority;
	action: NotificationAction;
	seen: boolean;
	created_at: string;
}

export type NotificationsResponse = ApiResponseWithPagination<TNotification> & {
	unread_count: number;
};
